export default __webpack_public_path__ + "static/audi-iconfont-2bc4d20b4681cb01ae4c7a025d9169d8.ttf";